import { TodayState } from './types'

export const state: TodayState = {
  loadingList: false,
  consultationsList: [
    {
      id: 1,
      image:
        'https://media.istockphoto.com/vectors/happy-young-woman-watching-into-rounded-frame-isolated-on-white-3d-vector-id1296058958?k=20&m=1296058958&s=612x612&w=0&h=AsZaq2ZGD4rIyr7vCuc7NXuAz7954D8wYW93siKAHA4=',
      first_name: 'Ana',
      last_name: 'Corona Tapia',
      week_number: 12,
      day_number: 8
    },
    {
      id: 2,
      image:
        'https://i.pinimg.com/originals/4b/5d/19/4b5d1954fbb5b6bad18f0ac25c4ab3c3.png',
      first_name: 'Sofía',
      last_name: 'Menera Ramirez',
      week_number: 22,
      day_number: 12
    },
    {
      id: 3,
      image:
        'https://2.bp.blogspot.com/-x4eBRzgzgTg/WKn5Lq5VzrI/AAAAAAAABrE/mDo0ehzhhtMqcTc4gR62EQ203U-9ljP1QCLcB/s1600/myAvatar.jpeg',
      first_name: 'Teresa',
      last_name: 'Mendez Camarena',
      week_number: 2,
      day_number: 11
    },
    {
      id: 4,
      image:
        'https://i.pinimg.com/originals/4b/5d/19/4b5d1954fbb5b6bad18f0ac25c4ab3c3.png',
      first_name: 'Selina',
      last_name: 'Montañez Mujica',
      week_number: 13,
      day_number: 2
    },
    {
      id: 5,
      image:
        'https://i.pinimg.com/originals/4b/5d/19/4b5d1954fbb5b6bad18f0ac25c4ab3c3.png',
      first_name: 'Erendira',
      last_name: 'Luna Perez',
      week_number: 16,
      day_number: 6
    }
  ]
}
